import { useMemo } from 'react';
import { usePrevious } from '@atlassian/jira-platform-react-hooks-use-previous/src/common/utils/index.tsx';
import { useBoardSelector } from '../../index.tsx';
import {
	numberOfUserHasCompleteAssignedIssuesSelector,
	shouldShowUnassignedFilterNudgeSelector,
} from '../../selectors/unassigned-work/unassigned-work-selector.tsx';
import { workIssuesCountSelector } from '../../selectors/work/work-selectors.tsx';

export const useShouldShowUnassignedFilterNudge = () => {
	const isNotEmptyBoard = useBoardSelector(workIssuesCountSelector) > 0;
	const numberOfCompleteIssues = useBoardSelector(numberOfUserHasCompleteAssignedIssuesSelector);
	const shouldShowUnassignedFilterNudge = useBoardSelector(shouldShowUnassignedFilterNudgeSelector);
	const previousNumberOfCompleteIssues =
		usePrevious(isNotEmptyBoard ? numberOfCompleteIssues : null) || null;

	// only show the nudge if the board is not empty and the user has just landed this page or completed an issue
	const shouldShowNudge = useMemo(
		() =>
			isNotEmptyBoard &&
			shouldShowUnassignedFilterNudge &&
			(previousNumberOfCompleteIssues === null ||
				previousNumberOfCompleteIssues + 1 === numberOfCompleteIssues),
		// use the value of previousNumberOfCompleteIssues before it is updated in the useEffect
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[isNotEmptyBoard, shouldShowUnassignedFilterNudge, numberOfCompleteIssues],
	);

	return shouldShowNudge;
};
